import { lazy } from 'react';

import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from '@src/packages/utils';

import { PATHS } from './constants';

const WorkerScoreNotes = lazy(() => import('./screens/WorkerScoreNotes'));

const WorkerScoreRanking = lazy(() => import('./screens/WorkerScoreRanking'));

const routes = [
  {
    component: WorkerScoreNotes,
    path: PATHS.NOTES,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.USERS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.NOTES}`,
  },
  {
    component: WorkerScoreRanking,
    path: PATHS.RANKING,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.USERS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.RANKING}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.WORKER_SCORE, routes);
